import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_sacaru-landing/artifacts/h7wje3z2_Logo%20Distribuidora%20Sacaru%20SVG-01.png";

const navItems = [
  { id: "nosotros", label: "Nosotros" },
  { id: "servicios", label: "Servicios" },
  { id: "metodologia", label: "Método AI" },
  { id: "contacto", label: "Contacto" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl border-b border-white/10"
          : "backdrop-blur-md"
      }`}
      style={{ backgroundColor: "rgba(89, 89, 89, 0.5)" }}
    >
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <button
          onClick={() => handleNav("hero")}
          className="flex items-center gap-3 group"
          data-testid="nav-logo"
        >
          <img
            src={LOGO_URL}
            alt="Sacaru Distribuidora"
            className="h-[60px] w-auto"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {navItems.map((it) => (
            <button
              key={it.id}
              onClick={() => handleNav(it.id)}
              data-testid={`nav-link-${it.id}`}
              className="text-white/80 hover:text-white text-sm tracking-wide link-underline transition-colors"
            >
              {it.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            onClick={() => handleNav("contacto")}
            data-testid="nav-cta-contacto"
            className="btn-primary relative z-10 bg-[#C7343D] text-white px-6 py-3 text-xs font-semibold tracking-[0.2em] uppercase border border-[#C7343D] hover:border-[#F3901A]"
          >
            Cotizar Ahora
          </button>
        </div>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {navItems.map((it) => (
              <button
                key={it.id}
                onClick={() => handleNav(it.id)}
                data-testid={`mobile-nav-link-${it.id}`}
                className="text-white text-2xl font-display text-left"
              >
                {it.label}
              </button>
            ))}
            <button
              onClick={() => handleNav("contacto")}
              data-testid="mobile-nav-cta"
              className="bg-[#C7343D] text-white px-6 py-4 text-sm font-semibold tracking-[0.2em] uppercase mt-4"
            >
              Cotizar Ahora
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
